import axios from "axios";

// AXIOS CONFIG
const AxiosDownload = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}api`,
  responseType: "blob",
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});

/**
 * Interceptor for dynamic token and clean headers
 */
AxiosDownload.interceptors.request.use((request) => {
  // Récupère toujours le token à jour
  const jwt = localStorage.getItem("jwt");

  if (jwt) {
    request.headers["Authorization"] = `Bearer ${jwt}`;
  }

  // Ne pas forcer Content-Type sur les GET sans body
  if (request.method.toLowerCase() === "get") {
    delete request.headers["Content-Type"];
  }

  return request;
});

AxiosDownload.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default AxiosDownload;
